<template>
    <div class="container">
        <div class="breadBox" v-if="href=='customer' ">
            <el-button @click="back" class="backBtn"><i class="el-icon-arrow-left"></i> 返回</el-button>
            <div class="breadItem"><span>客户管理</span></div>
            <div class="breadItem"><span>客户列表</span></div>
            <div class="breadItem"><span>客户详情</span></div>
        </div>
        <div class="breadBox" v-if="href=='jiedanDetail'">
            <el-button @click="back" class="backBtn"><i class="el-icon-arrow-left"></i> 返回</el-button>
            <div class="breadItem"><span>订单管理</span></div>
            <div class="breadItem"><span>订单列表</span></div>
            <div class="breadItem"><span>订单详情</span></div>
            <div class="breadItem"><span>接单方详情</span></div>
        </div>
        <div class="breadBox" v-if="href=='fadanDetail'">
            <el-button @click="back" class="backBtn"><i class="el-icon-arrow-left"></i> 返回</el-button>
            <div class="breadItem"><span>订单管理</span></div>
            <div class="breadItem"><span>订单列表</span></div>
            <div class="breadItem"><span>订单详情</span></div>
            <div class="breadItem"><span>发单方详情</span></div>
        </div>
        <div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.8)">
            <!-- 第一块 -->
            <div class="panelBlock">
                <div class="panelTitle">
                    <div class="innerLine">账号信息</div>
                </div>
                <div class="panelContent">
                    <div class="oneRow">
                        <div class="oneCol third">
                            <img :src="IMG_PREV+headPic" alt="" class="headerLogo" v-if="headPic" @click="prevImg(headPic)">
                            <img src="../../assets/images/icon/icon_person.png" alt="" class="headerLogo" v-if="!headPic">
                            <div class="label">注册手机号</div>
                            <div class="desc">{{infoObj.user_cellphone}}</div>
                        </div>
                        <div class="oneCol third">
                            <div class="label justify">身份</div>
                            <div class="desc">{{infoObj.user_type | turnValToText("user_type")}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 第2块 -->
            <div class="panelBlock">
                <div class="panelTitle">
                    <div class="innerLine">
                        企业基础信息
                        <span>
                            <span :class="{green:infoObj.auth_result=='y',red:infoObj.auth_result=='n',orange:infoObj.auth_result=='p'}">
                                ({{infoObj.auth_result | turnValToText("auth_result")}})
                            </span>
                            <span v-if="!infoObj.auth_result">(未提交审核资料)</span>

                        </span>

                        <el-button size="mini" type="primary" class="editBtn" @click="editBasicInfoVisible = true">编辑</el-button>

                    </div>
                </div>
                <div class="panelContent">
                    <div class="oneRow">
                        <div class="oneCol third">
                            <div class="label">公司名称</div>
                            <div class="desc">{{infoObj.company_name}}</div>
                        </div>
                        <div class="oneCol third">
                            <div class="label">公司电话</div>
                            <div class="desc">{{infoObj.company_phone}}</div>
                        </div>
                        <div class="oneCol third">
                            <div class="label">公司地址</div>
                            <div class="desc">
                                {{infoObj.company_province}}{{infoObj.company_city}}{{infoObj.company_district}}
                                {{infoObj.company_address}}
                            </div>
                        </div>
                    </div>
                    <div class="oneRow" v-if="infoObj.user_type==1">
                        <div class="oneCol third">
                            <div class="label">业务负责人</div>
                            <div class="desc">
                                {{infoObj.company_key_person}}
                            </div>
                        </div>
                        <div class="oneCol third">
                            <div class="label">负责人电话</div>
                            <div class="desc">
                                {{infoObj.company_key_person_phone}}
                            </div>

                        </div>


                    </div>
                    <div class="oneRow">
                        <div class="oneCol third" v-if="infoObj.user_type==2">
                            <div class="label">法定代表人</div>
                            <div class="desc">{{infoObj.company_key_person}}</div>
                        </div>
                        <div class="oneCol third">
                            <div class="label">营业执照号</div>
                            <div class="desc">{{infoObj.company_license_number}}</div>
                        </div>
                        <div class="oneCol third">
                            <div class="label">上次登录时间</div>
                            <div class="desc">{{infoObj.lastLoginTime}}</div>
                        </div>

                    </div>
                    <div class="oneRow highRow">
                        <div class="oneCol third">
                            <div class="label">营业执照</div>
                            <div class="desc"><img :src="IMG_PREV+licenseFile" alt="" class="pic" @click="prevImg(licenseFile)"></div>
                        </div>
                        <div class="oneCol auto" v-if="infoObj.user_type==2">
                            <div class="label">工厂图片</div>
                            <div class="desc">
                                <img :src="IMG_PREV+list.image_file" alt="" class="pic" v-for="list in userAuthFactoryPic"
                                    @click="prevImg(list.image_file)">
                            </div>

                        </div>
                    </div>
                    <div class="oneRow" v-if="infoObj.user_type==1">
                        <div class="oneCol ">
                            <div class="label justify">品牌</div>
                            <div class="desc">
                                {{infoObj.company_brand}}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- 第3块 -->
            <div class="panelBlock">
                <div class="panelTitle">
                    <div class="innerLine">
                        企业业务信息
                        <el-button size="mini" type="primary" class="editBtn" @click="openBusinessEditModal">编辑</el-button>
                    </div>
                </div>
                <div class="panelContent">
                    <div class="oneRow" v-if="infoObj.user_type==2">
                        <div class="oneCol third">
                            <div class="label">主要品质产出</div>
                            <div class="desc">
                                <span class="item" v-for="list in mainQuantityStr.list" v-if="list.isSelect==1">{{list.dataName}}</span>
                            </div>
                        </div>
                        <!-- <div class="oneCol third">
							<div class="label">是否有供款</div>
							<div class="desc">-</div>
						</div> -->
                        <div class="oneCol third">
                            <div class="label long">是否有采购面辅料的能力</div>
                            <div class="desc">
                                <span v-if="canBuyFabricAbility">是</span>
                                <span v-if="!canBuyFabricAbility">否</span>
                            </div>
                        </div>
                    </div>
                    <div class="oneRow" v-if="infoObj.user_type==1">
                        <div class="oneCol third">
                            <div class="label">主营渠道</div>
                            <div class="desc">
                                <span v-for="list in channelList" v-if="list.isSelect==1" class="item chanelItem">
                                    {{list.dataName}}
                                </span>
                            </div>
                        </div>

                    </div>
                    <div class="oneRow multi">
                        <div class="oneCol">
                            <div class="label">主营品类</div>
                            <div class="desc ">
                                <ul>
                                    <li v-for="list in product" v-if="list.checked">
                                        <span class="item">{{list.dataName}} ：</span>
                                        <span class="item" v-for="list2 in list.list" v-if="list2.checked">{{list2.name}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="oneRow multi" v-if="infoObj.user_type==2">
                        <div class="oneCol auto">
                            <div class="label long">所能处理的加工环节</div>
                            <div class="desc">
                                <span class="item processItem" v-for="list in handleNeedProcessingLink.list" v-if="list.isSelect==1">{{list.dataName}}</span>
                                <span class="item processItem " v-if="handleNeedProcessingLink.other">{{handleNeedProcessingLink.other}}</span>
                            </div>
                        </div>
                        <div class="oneCol auto">
                            <div class="label long">所能处理的特殊工艺</div>
                            <div class="desc">
                                <span class="item processItem" v-for="list in handleSpecialProcess.list" v-if="list.isSelect==1">{{list.dataName}}</span>
                                <span class="item processItem" v-if="handleSpecialProcess.other">{{handleSpecialProcess.other}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="oneRow" v-if="infoObj.user_type==2">
                        <div class="oneCol">
                            <div class="label">员工总人数</div>
                            <div class="desc" v-if="!staffInfo.employeeData.total">
                                {{staffNumber}}人
                            </div>
                            <div class="desc" v-if="staffInfo.employeeData.total">
                                <span class="item">{{staffInfo.employeeData.total}} 人</span>
                                (<span class="item" v-for="list in staffInfo.employeeData.childrenLists">
                                    {{list.name}} {{list.num}} 人
                                </span>)

                            </div>
                        </div>
                    </div>
                    <div class="oneRow" v-if="infoObj.user_type==2">
                        <div class="oneCol">
                            <div class="label">设备总数</div>
                            <div class="desc" v-if="staffInfo.machineData.total">
                                <span class="item">{{staffInfo.machineData.total}} 人</span>
                                (<span class="item" v-for="list in staffInfo.machineData.childrenLists">
                                    {{list.name}} {{list.num}} 台
                                </span>)

                            </div>
                        </div>
                    </div>
                    <div class="oneRow" v-if="infoObj.user_type==2">
                        <div class="oneCol third">
                            <div class="label">产能</div>
                            <div class="desc">
                                {{capcity}}
                            </div>
                        </div>
                        <div class="oneCol third">
                            <div class="label">意向接单区域</div>
                            <div class="desc">{{favoriteArea}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 第4块 -->
            <div class="panelBlock">
                <div class="panelTitle">
                    <div class="innerLine">其他信息</div>
                </div>
                <div class="panelContent" style="padding-bottom: 1rem;">
                    <div class="oneRow">
                        <div class="oneCol third">
                            <div class="label">注册渠道</div>
                            <div class="desc">{{infoObj.token_type | turnValToText("token_type")}}</div>
                        </div>
                        <div class="oneCol third">
                            <div class="label">注册时间</div>
                            <div class="desc">{{infoObj.user_register_time}}</div>
                        </div>
                        <div class="oneCol third">
                            <div class="label">认证状态</div>
                            <div class="desc">
                                <span :class="{green:infoObj.auth_result=='y',red:infoObj.auth_result=='n',orange:infoObj.auth_result=='p'}">{{infoObj.auth_result | turnValToText("auth_result")}}</span>
                                <span v-if="!infoObj.auth_result">未提交审核资料</span>
                                <el-button type="primary" @click="openAuth" v-if="infoObj.auth_result=='p'&&functionAuthCustomer"
                                    size="mini">审核企业信息</el-button>
                                <el-button type="primary" @click="openAuth" v-if="(infoObj.auth_result=='y'||infoObj.auth_result=='n') &&functionAuthCustomer"
                                    size="mini">重新审核企业信息</el-button>
                                <!-- <el-button type="primary" @click="openAuth" > 测试审核企业信息</el-button> -->
                            </div>
                        </div>
                    </div>
                    <div class="oneRow multi">
                        <div class="oneCol auto ">
                            <div class="label">审核记录</div>
                            <div class="desc greyThead">
                                <el-table stripe :data="userAuthRecordList" tooltip-effect="dark" style="width: 100%">
                                    <el-table-column label="序号" width="50">
                                        <template slot-scope="scope">{{scope.$index+1}}</template>
                                    </el-table-column>
                                    <el-table-column label="认证审核操作账号" width="140">
                                        <template slot-scope="scope">{{ scope.row.user_cellphone }}</template>
                                    </el-table-column>
                                    <el-table-column label="提交认证时间" width="170">
                                        <template slot-scope="scope">{{ scope.row.auth_user_submit_time }}</template>
                                    </el-table-column>
                                    <el-table-column label="认证审核时间" width="170">
                                        <template slot-scope="scope">{{ scope.row.auth_admin_submit_time }}</template>
                                    </el-table-column>
                                    <el-table-column label="认证结果" width="170">
                                        <template slot-scope="scope">{{ scope.row.auth_result |turnValToText("auth_result")}}</template>
                                    </el-table-column>
                                    <el-table-column label="说明">
                                        <template slot-scope="scope">{{ scope.row.auth_reject_causation }}</template>
                                    </el-table-column>

                                </el-table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        <el-dialog custom-class="prevImgModal" title="图片预览" center :visible.sync="isShowImgModal" top="3vh">
            <div class="prevImgModalContent"> <img :src="IMG_PREV+currentPrevImg" alt=""> </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="isShowImgModal = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="修改业务" :visible.sync="isShowBusinessEditModal" width="900px">
            <div class="editBusinessModal">
                <!-- 生产商才有的选择 -->
                <div class="factoryOptionBox" v-if="infoObj.user_type==2">
                    <div class='oneLine'>
                        <div class="myLabel">是否有采购面辅料的能力 </div>
                        <div class="optionBox">
                            <el-radio-group v-model="editBusinessForm.canBuyFabricAbility">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">无</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class='oneLine'>
                        <div class="myLabel">产能 </div>
                        <div class="optionBox">
                            <el-input v-model="editBusinessForm.capcity" placeholder="请输入产能,如 800件/天" clearable></el-input>
                        </div>
                    </div>
                    <div class='oneLine'>
                        <div class="myLabel">意向接单区域 </div>
                        <div class="optionBox">
                            <el-input v-model="editBusinessForm.favoriteArea" placeholder="请输入意向接单区域" clearable></el-input>
                        </div>
                    </div>
                    <div class='oneLine'>
                        <div class="myLabel">您所能处理的加工环节: </div>
                        <div class="optionBox">
                            <el-checkbox v-for="(list,index) in editBusinessForm.handleNeedProcessingLink.list" :key="list.dataName + index"
                                :label="list.dataName" :checked="list.isSelect == 1" @change="(e) => selectHandleNeedProcessingLink(e, list) "></el-checkbox>
                            其他：<input class="otherInput" type="text" v-model="editBusinessForm.handleNeedProcessingLink.other"
                                placeholder="请输入">
                        </div>
                    </div>
                    <div class='oneLine'>
                        <div class="myLabel">您所能处理的特殊工艺: </div>
                        <div class="optionBox">
                            <el-checkbox v-for="(list,index) in editBusinessForm.handleSpecialProcess.list" :key="list.dataName + index"
                                :label="list.dataName" :checked="list.isSelect == 1" @change="(e) => selectHandleSpecialProcess(e, list) "></el-checkbox>
                            其他：<input class="otherInput" type="text" v-model="editBusinessForm.handleSpecialProcess.other"
                                placeholder="请输入">
                        </div>
                    </div>
                    <div class='oneLine'>
                        <div class="myLabel">您的主要品质产出: </div>
                        <div class="optionBox">
                            <el-radio-group v-model="qualitySelect">
                                <el-radio :label="list.dataName" v-for="(list,index) in editBusinessForm.mainQuantityStr.list"
                                    :key="list.dataName + index" @change="(e) => selectMainQuantityStr(e, list) "></el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <!-- 销售商才有的选择 -->
                <div class='oneLine' v-if="infoObj.user_type==1">
                    <div class="myLabel"><i class="red">*</i> 主营渠道 <span class="smallDes">(至少选择一个)</span> </div>
                    <div class="optionBox" v-if="isShowBusinessEditModal" style="display: inline-block;">
                        <el-checkbox v-for="(list,index) in editBusinessForm.channelList" :key="list.dataName + index"
                            :label="list.dataName" :checked="list.isSelect == 1" @change="(e) => selectChannel(e, list) "></el-checkbox>
                    </div>
                </div>
                <!-- 共有的的选择 -->
                <div class="oneLine">
                    <div class="myLabel"> <i class="red">*</i> 主营品类 <span class="smallDes">(至少选择一个)</span> </div>
                    <div class="optionBox">
                        <div class="cate-line" v-for="(item, index) in editBusinessForm.product" :key="item.dataName + index">
                            <div class="cate-lab">{{item.dataName}}</div>
                            <div class="cate-select w">
                                <el-checkbox :label="ele.name" v-for="(ele, i) in item.list" :key="ele+i" v-model="ele.checked"
                                    @change="changeClothesTag"></el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowBusinessEditModal = false">取 消</el-button>
                <el-button type="primary" @click="submitBusinessEdit">确 定</el-button>
            </span>
        </el-dialog>

        <authmodal :current="currentAuthList" :isShow="isShowModal" @close="closeModal" @submitSucess="getDetail"></authmodal>
        <edit-basic-info 
			:visible.sync="editBasicInfoVisible"
			:user-id="userId"
			:user-type="infoObj.user_type"
			@on-success="editBasicInfoSuccess"
		/>
    </div>
</template>

<script>
	import editBasicInfo from './components/editBasicInfo.vue'
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxPost,
        api
    } from '@/common/request.js'
    import {
        ajaxApp,
        api_app
    } from '@/common/request_app.js'
    import authmodal from '@/components/authModal.vue'
    export default {
        name: 'adminIndex',
        data() {
            return {
                currentPrevImg: '',
                isLoading: false,
                authId: "",
                djs: "",
                userId: "",
                headPic: "",
                licenseFile: "",
                userAuthFactoryPic: [],
                infoObj: {},
                regStrObj: {},
                canBuyFabricAbility: "",
                mainQuantityStr: [],
                handleNeedProcessingLink: [],
                handleSpecialProcess: [],
                product: [], //主营品类
                channelList: [], //主营渠道
                staffNumber: "",
                staffInfo: {
                    employeeData: {},
                    machineData: {}
                },
                userAuthRecordList: [],
                isShowModal: false, //审核的modal
                isShowImgModal: false, //图片预览
                currentAuthList: {},
                timer: '',
                href: '',
                isShowBusinessEditModal: false, //编辑公司业务的弹窗
                qualitySelect: '',
                capcity: '', //产能
                favoriteArea: '', //意向接单区域
                editBusinessForm: {
                    product: [],
                    channelList: [],
                    canBuyFabricAbility: '',
                    handleNeedProcessingLink: '',
                    handleSpecialProcess: '',
                    mainQuantityStr: '',
                    staffNumber: '',
                    capcity: '', //产能
                    favoriteArea: '', //意向接单区域
				},
				editBasicInfoVisible: false // 编辑基础信息弹框

            }
        },
        computed: {
            functionAuthCustomer() {
                return utils.getCurrentFunction().indexOf("authCustomerIdentitySubmit") > -1
            },
            IMG_PREV() {
                return api.imgPrev
            }
        },
        components: {
			authmodal,
			editBasicInfo
        },
        methods: {
			editBasicInfoSuccess(e) {
				this.getDetail()
			},
            prevImg(url) {
                this.isShowImgModal = true
                this.currentPrevImg = url
            },
            // 业务编辑-服装品类选择
            openBusinessEditModal() {
                this.editBusinessForm.product = JSON.parse(JSON.stringify(this.product))
                this.editBusinessForm.channelList = JSON.parse(JSON.stringify(this.channelList))
                this.editBusinessForm.canBuyFabricAbility = this.canBuyFabricAbility
                this.editBusinessForm.handleNeedProcessingLink = JSON.parse(JSON.stringify(this.handleNeedProcessingLink)) ||
                    {}
                this.editBusinessForm.handleSpecialProcess = JSON.parse(JSON.stringify(this.handleSpecialProcess)) || {}
                this.editBusinessForm.mainQuantityStr = JSON.parse(JSON.stringify(this.mainQuantityStr)) || {}
                this.editBusinessForm.staffNumber = this.staffNumber
                this.editBusinessForm.capcity = this.capcity
                this.editBusinessForm.favoriteArea = this.favoriteArea

                // this.qualitySelect = this.editBusinessForm.mainQuantityStr&&this.editBusinessForm.mainQuantityStr.list ? this.editBusinessForm.mainQuantityStr.list.filter(item => item.isSelect == 1)[0].dataName : ''

                this.isShowBusinessEditModal = true

            },
            initPage() {
                this.isShowBusinessEditModal = false
                this.getDetail()
            },
            // 选择您的主要品质产出
            selectMainQuantityStr(e, item) {
                console.log(e)
                this.editBusinessForm.mainQuantityStr.list.forEach(item => {
                    item.dataName == e ? item.isSelect = '1' : item.isSelect = '0'
                })
            },
            // 选择您所能处理的加工环节
            selectHandleNeedProcessingLink(e, item) {
                e ? item.isSelect = '1' : item.isSelect = '0'
            },
            // 选择您所能处理的特殊工艺
            selectHandleSpecialProcess(e, item) {
                e ? item.isSelect = '1' : item.isSelect = '0'
            },
            selectChannel(e, item) {
                e ? item.isSelect = '1' : item.isSelect = '0'
            },
            changeClothesTag() {
                this.editBusinessForm.product.forEach(item => {
                    item.checked = item.list.some(ele => ele.checked)
                })
            },
            submitBusinessEdit() {
                let _this = this
                if (!this.editBusinessForm.product.some(item => item.checked)) {
                    this.$message.error('请至少选择一个品类')
                    return false
                }
                if (this.infoObj.user_type == 1) { //品牌商，参数少的
                    if (!this.editBusinessForm.channelList.some(item => item.isSelect == '1')) {
                        this.$message.error('请至少选择一个渠道')
                        return false
                    }
                    let params = {
                        product: this.editBusinessForm.product,
                        channel: {
                            list: this.editBusinessForm.channelList
                        }
                    }
                    let arg = {
                        userId: this.userId,
                        regStr: JSON.stringify(params)
                    }
                    ajaxPost('/admin/yijiajiaUserAuth/editExtraInfo', arg).then(function(res) {
                        console.log(res)
                        if (res.errorCode == 200) {
                            _this.$message.success("修改成功")
                            _this.initPage()
                        } else {

                        }
                    })
                } else { //生产商，参数多的
                    let params = {
                        product: this.editBusinessForm.product,
                    }
                    let params2 = {

                        handleNeedProcessingLink: this.editBusinessForm.handleNeedProcessingLink,
                        handleSpecialProcess: this.editBusinessForm.handleSpecialProcess,
                        mainQuantityStr: this.editBusinessForm.mainQuantityStr,
                        staffsNumber: this.editBusinessForm.staffNumber,
                        canBuyFabricAbility: this.editBusinessForm.canBuyFabricAbility,
                        capcity: this.editBusinessForm.capcity,
                        favoriteArea: this.editBusinessForm.favoriteArea,
                    }
                    let arg = {
                        userId: this.userId,
                        regStr: JSON.stringify(params),
                        staffDevice: JSON.stringify(params2),
                    }
                    console.log(params, 'params1')
                    console.log(params2, 'params2')
                    console.log(arg, 'arg')
                    ajaxApp('/yijiajiaUserInfo/editExtraUserInfo', arg).then(function(res) {
                        console.log(res)
                        if (res.errorCode == 200) {
                            _this.$message.success("修改成功")
                            _this.initPage()
                        } else {

                        }
                    })
                }

            },
            getDjs() {
                let _this = this
                let endDate = this.infoObj.auth_user_submit_time
                if (endDate && _this.infoObj.auth_result == 'p') {
                    _this.timer = setInterval(function() {
                        console.log(_this.timer)
                        _this.djs = utils.computeDjs(endDate, 2)
                    }, 1000)
                }


            },
            back() {
                this.$router.back()
            },
            closeModal() {
                this.isShowModal = false
            },
            openAuth() {
                let list = {
                    company_name: this.infoObj.company_name,
                    user_id: this.infoObj.user_id,
                    auth_id: this.infoObj.auth_id
                }
                this.currentAuthList = list
                this.isShowModal = true
            },
            getParam() {
                this.userId = this.$route.params.userId
                this.href = this.$route.params.href
            },
            getDetail() {
                let _this = this
                _this.isLoading = true
                let args = {
                    userId: _this.userId,
                }
                ajaxPost('/admin/yijiajiaUserAuth/getUserAuthByAId', args).then(function(res) {
                    _this.isLoading = false

                    if (res.data) {
                        //基础信息加图片
                        _this.infoObj = res.data.userAuthDetail ? res.data.userAuthDetail : {}
                        _this.infoObj.user_type = _this.infoObj.userType
                        //品牌
                        if (_this.infoObj.company_brand) {
                            let arr = _this.infoObj.company_brand.split(",")
                            _this.infoObj.company_brand = arr.join(" / ")
                        }

                        _this.userId = _this.infoObj.user_id
                        _this.headPic = res.data.headPic
                        _this.licenseFile = res.data.licenseFile
                        _this.staffNumber = res.data.staffNumber
                        _this.imgFile = res.data.imgFile
                        _this.userAuthFactoryPic = res.data.userAuthFactoryPic || []
                        _this.userAuthRecordList = res.data.userAuthRecordList || []
                        //regStr
                        if (res.data.regStr) {
                            _this.regStrObj = JSON.parse(res.data.regStr)
                            console.log(_this.regStrObj)
                            _this.product = _this.regStrObj.product
                            _this.channelList = _this.regStrObj.channel ? _this.regStrObj.channel.list : []
                            
                            // _this.product=wordData.clothesData.product//del 可以删除
                        } else { //主营品类数据丢失的情况,从本地数据字典里获取
                            _this.product=wordData.clothesData.product
                        }
                        if (res.data.staffInfo) {
                            _this.staffInfo = JSON.parse(res.data.staffInfo)

                        }
                        if (res.data.staffDevice) {
                            console.log(newObj, "newObj")
                            let newObj = JSON.parse(res.data.staffDevice)
                            _this.canBuyFabricAbility = newObj.canBuyFabricAbility
                            _this.mainQuantityStr = newObj.mainQuantityStr
                            _this.handleSpecialProcess = newObj.handleSpecialProcess
                            _this.handleNeedProcessingLink = newObj.handleNeedProcessingLink

                            _this.capcity = newObj.capcity
                            _this.favoriteArea = newObj.favoriteArea
                            //del 以下可以删除
                            // console.log(wordData.mainQuantityStr)
                            // _this.mainQuantityStr = wordData.mainQuantityStr
                            // _this.handleSpecialProcess = wordData.handleSpecialProcess
                            // _this.handleNeedProcessingLink = wordData.handleNeedProcessingLink

                        }else{
                            _this.mainQuantityStr = wordData.mainQuantityStr
                            _this.handleSpecialProcess = wordData.handleSpecialProcess
                            _this.handleNeedProcessingLink = wordData.handleNeedProcessingLink
                        }
                        console.log(_this.staffInfo, "设备、人员")
                        //倒计时
                        _this.getDjs()

                    }
                    
                    // regStr:{product:[],channel:{}},
                    // staffDevice:{
                    //     handleNeedProcessingLink:{list:[],other:{}},
                    //     handleSpecialProcess:{list:[],other:{}},
                    //     mainQuantityStr:{list:[]},
                    //     canBuyFabricAbility: "true"
                    //     capcity: "q"
                    //     favoriteArea: "杭州",
                    //     staffsNumber: "2"
                    // },
                    // staffInfo:{
                    //     employeeData:{},
                    //     machineData:{}
                    // }

// 


                }, function(res) {
                    _this.isLoading = false
                })
            },


        },
        mounted() {
            let _this = this
            this.getParam()
            this.getDetail()
        },
        destroyed() {
            let _this = this
            console.log(_this.timer, "销毁定时器")
            clearInterval(_this.timer)


        }
    }
</script>

<style scoped lang="scss">
    * {
        // outline: 1px solid blue;
    }

    .item {
        margin-right: 0.2rem;
    }

    .contentWrap {
        padding: 0.15rem 0.5rem;
    }

    .headerLogo {
        width: 0.7rem;
        height: 0.7rem;
        margin-right: 1rem;
    }

    .panelBlock {

        //主营渠道后加斜杠
        .chanelItem,
        .processItem {
            margin-right: 0;
        }

        .chanelItem:not(:last-child)::after,
        .processItem:not(:last-child)::after {
            content: "  / "
        }

        .pic {
            max-height: 100%;
            width: auto;
            min-width: 2rem;
            height: 2rem;
            background: #eee;
            margin-right: 0.2rem;
        }

        .panelTitle {
            padding: 0.7rem 0 0.3rem;
            color: #4C4C4C;

            .innerLine {
                border-left: 4px solid $lighterColor;
                font-size: 17px;
                padding-left: 0.25rem;
            }
        }

        .panelContent {
            background: #fff;
            padding: 0.4rem 0;
            font-size: 14px;

            .oneRow.highRow {
                height: 2rem;
            }

            .oneRow.multi {
                height: auto;
            }

            .oneRow {
                display: flex;
                height: 0.7rem;
                line-height: 0.7rem;
                padding: 0.1rem;
                padding-left: 0.5rem;

                .oneCol.third {
                    width: 33%;
                }

                .oneCol.auto {
                    flex: 1;
                }

                // .oneCol.auto{flex:1;}
                .oneCol {
                    display: flex;

                    .label.long {
                        width: 4rem;
                    }

                    .label {
                        color: #aaa;
                        padding: 0 0.2rem;
                        width: 2.5rem;
                    }

                    .label.justify {
                        text-align: justify;
                        text-align-last: justify;
                        width: 1.4rem;
                        margin-right: 1.1rem;
                    }

                    .desc {
                        color: #3a3a3a;
                        display: flex;
                        flex: 1;
                    }

                }
            }
        }
    }

    // 编辑主营业务等弹窗
    .editBusinessModal {
        .oneLine {
            padding-top: 10px;

            .myLabel {
                font-weight: bold;
                margin-right: 10px;
            }

            .optionBox {
                padding: 10px 20px;

                .cate-lab {
                    padding: 0px 0 5px;
                    display: inline-block;
                }
            }
        }

        .smallDes {
            color: #999;
            font-size: 12px;
            font-weight: normal;
        }

        .el-checkbox {
            margin-bottom: 5px;
        }

        .cate-select {
            padding-bottom: 10px;

            .el-checkbox {
                min-width: 80px;
            }
        }

        .otherInput {
            border: 0;
            outline: 0;
            border-bottom: 1px solid #aaa;
            width: 100px;
        }

        .el-input {
            width: 300px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/detail.vue